import React from 'react';
import ZFSCalculator from './components/ZFSCalculator';

function App() {
  return (
    <div className="min-h-screen">
      <ZFSCalculator />
    </div>
  );
}

export default App;